export default () =>
  process.env.RELEASE_TAG
    ? process.env.RELEASE_TAG
    : (process.env.HEAD?.substring(0, 7) as string)
